import {
  enumCache,
  fields
} from 'modules';

import { usePaymentCountrySelectField } from './dataService';



export const PaymentCountrySelectField = fields.genEnumSelectFieldComponent<string, enumCache.IGenericEnum<string>>(usePaymentCountrySelectField, {
  label: 'Country'
});


